import React from 'react';
import { Box } from '@mui/material';
import {
  MailOutlineOutlined,
  PersonOutlineOutlined,
  AccountCircleOutlined,
} from '@mui/icons-material';
import { Contact } from 'store/api/models';
import { JFormik, JItem } from '@centerpiece/components';
import * as Yup from 'yup';
import { useContactTooltip } from 'jformik/useContactForm';
import { useOrganizationTooltip } from 'jformik/useOrganizationForm';

export const ContactTooltip = (contact: Contact) => {
  const orgform = useOrganizationTooltip();
  const form = useContactTooltip();
  return (
    <Box key={`contact-${contact.id}`} sx={{ width: '350px', py: 1 }}>
      <JFormik
        initialValues={
          contact?.organization_r
            ? {
                ...contact?.organization_r,
                role: contact.role_r?.name,
                type: 'organization',
              }
            : {
                ...contact,
                name: contact.firstname
                  ? `${contact.firstname} ${contact.lastname}`
                  : undefined,
                role: contact.role_r?.name,
                organization: contact.organization_r?.name,
              }
        }
        containerGridProps={{ spacing: 1 }}
        disabled={true}
        validationSchema={Yup.object()}
        form={
          contact?.role_r?.type && contact?.role_r?.type === 'External'
            ? contact?.organization_r
              ? orgform.form
              : form.form
            : [
                {
                  precondition: (values: any) => values.name,
                  name: 'name',
                  label: 'Name',
                  itemType: 'textfield',
                  gridProps: { xs: 12 },
                  jItemProps: {
                    size: 'small',
                    InputProps: {
                      endAdornment: <PersonOutlineOutlined color="secondary" />,
                      size: 'small',
                    },
                  },
                },
                {
                  precondition: (values: any) => values.email,
                  name: 'email',
                  label: 'Email',
                  itemType: 'textfield',
                  gridProps: { xs: 12 },
                  jItemProps: {
                    size: 'small',
                    InputProps: {
                      endAdornment: <MailOutlineOutlined color="secondary" />,
                      size: 'small',
                    },
                  },
                },
                ...(contact.role_r?.name
                  ? [
                      {
                        name: 'role',
                        label: contact?.firstname ? (
                          <Box
                            component={'span'}
                            sx={{
                              color: theme => theme.palette.secondary.main,
                              fontWeight: 'bold',
                            }}
                          >
                            Automated Assignment via below Project Role
                          </Box>
                        ) : (
                          'Role assignment'
                        ),
                        itemType: 'textfield',
                        gridProps: { xs: 12 },
                        jItemProps: {
                          size: 'small',
                          InputProps: {
                            endAdornment: (
                              <AccountCircleOutlined color="secondary" />
                            ),
                            size: 'small',
                          },
                        },
                      } as JItem,
                    ]
                  : []),
                ...(contact?.status && !contact.author && !contact.partstat
                  ? [
                      {
                        name: 'status',
                        label: 'Read Receipt',
                        itemType: 'textfield',
                        // defaultValue: contact.status,
                        gridProps: { xs: 12 },
                        jItemProps: {
                          size: 'small',
                        },
                      } as JItem,
                    ]
                  : []),
                ...(contact.partstat
                  ? [
                      {
                        name: 'partstat',
                        label: 'Participant Status',
                        itemType: 'textfield',
                        // defaultValue: contact.status,
                        gridProps: { xs: 12 },
                        jItemProps: {
                          size: 'small',
                        },
                      } as JItem,
                    ]
                  : []),
                ...(contact?.author
                  ? [
                      {
                        name: 'author',
                        label: 'Author',
                        itemType: 'textfield',
                        defaultValue: 'Yes',
                        gridProps: { xs: 12 },
                        jItemProps: {
                          size: 'small',
                        },
                      } as JItem,
                    ]
                  : []),
              ]
        }
      />
    </Box>
  );
};
